__turbopack_context__.v({
  "metricsGrid": "PerformanceMetrics-module__hRtLaW__metricsGrid",
});
